<template>
  <div id="popup-install" class="py-5 px-10">
    <div v-show="signaturePopup == true">
      <registration-popup @onClosedSignature="onClosedSignature" :passValue="passId"></registration-popup>
    </div>
    <div v-show="signaturePopup == false">
      <h4>รายละเอียดการติดตั้งอุปกรณ์</h4>
      <vs-divider position="center"></vs-divider>

      <div class="content-block">
        <p class="mt-10">ส่วนที่ 1 ผู้ยื่นคำขอ(เจ้าของเรือ)</p>

        <vs-row class="mt-5 ml-5">
          <div class="flex ml-5">
            <vs-radio
              disabled
              class="mr-5"
              v-model="checkbox"
              vs-value="chkPerson"
              >บุคคลธรรมดา</vs-radio
            >
            <vs-radio
              disabled
              class="mr-5"
              v-model="checkbox"
              vs-value="chkLegal"
              >นิติบุคคล</vs-radio
            >
            <vs-radio
              disabled
              class="mr-10"
              v-model="checkbox"
              vs-value="chkOther"
              >อื่นๆ โปรดระบุ</vs-radio
            >
            <p class="mt-2 mx-2" v-show="checkbox == 'chkOther'">ระบุ</p>
            <vs-input disabled class="w-auto" v-show="checkbox == 'chkOther'" />
          </div>

          <vs-col class="mt-5" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <p>
              ชื่อ :
              {{
                info.personType == "นิติบุคคล"
                  ? info.certificateOperateName
                  : `${info.firstName} ${info.lastName}`
              }}
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <p>เลขบัตรประจำตัวประชาชน / เลขนิติบุคคล : {{ info.cardNumber }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>เลขรหัสประจำบ้าน : {{ info.houseCodeNumber }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12" v-if="info.personType == 'นิติบุคคล'">
            <p>ที่ตั้งสำนักงานใหญ่เลขที่ : {{ info.registrationOffice }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>ชื่ออาคาร : {{ info.buildingName }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>เลขที่ : {{ info.address }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>ชั้นที่ : {{ info.floor }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>
              ตำบล :
              {{
                info.personType == "นิติบุคคล"
                  ? info.certificateSubDistrict
                  : info.subDistrict
              }}
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>
              อำเภอ/เขต :
              {{
                info.personType == "นิติบุคคล"
                  ? info.certificateDistrict
                  : info.district
              }}
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12">
            <p>
              จังหวัด :
              {{
                info.personType == "นิติบุคคล"
                  ? info.certificateProvince
                  : info.province
              }}
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12">
            <p>
              รหัสไปรษณีย์ :
              {{
                info.personType == "นิติบุคคล"
                  ? info.certificatePostalCode
                  : info.postalCode
              }}
            </p>
          </vs-col>

          <vs-col class="mt-5" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12">
            <p>
              โทรศัพท์ :
              {{
                info.personType == "นิติบุคคล"
                  ? info.certificatePhoneNumber
                  : info.phoneNumber
              }}
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>
              อีเมล :
              {{
                info.personType == "นิติบุคคล"
                  ? info.certificateEmail
                  : info.email
              }}
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>ชื่อเรือ : {{ vessel.name }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>หมายเลขทะเบียนเรือ : {{ vessel.registrationNumber }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>ชื่อเรียกขาน (Call Sign) : {{ vessel.subName }}</p>
          </vs-col>

          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>วัสดุตัวเรือ : {{ vessel.material }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>ขนาดเรือ ความยาวตลอดลําเมตร : {{ vessel.size }} เมตร</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>ความกว้าง : {{ vessel.width }} เมตร</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>ความลึก : {{ vessel.depth }} เมตร</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>ตันกรอส : {{ vessel.tonGross }} ตันเนตชนิด</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>ชนิดเครื่องจักร : {{ vessel.machineType }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>ชื่อเครื่อง : {{ vessel.machineName }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>จำนวนเครื่อง : {{ vessel.machineNumber }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>จำนวนสูบ : {{ vessel.engineNumber }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12">
            <p>ขนาดเครื่องยนต์ : {{ vessel.engineSize }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="8" vs-sm="12" vs-xs="12">
            <p>
              ปริมารตรความจุถังน้ำมัน (ใช้สำหรับเรือ) :
              {{ vessel.capacity }} ลิตร
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <p>
              ปริมารตรความจุถังน้ำมัน (กรณีเรือบรรทุกน้ำมัน /
              เรือสถานีบริการจำหน่ายน้ำมัน) : {{ vessel.capacityForSale }} ลิตร
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>ประเภทการใช้ : {{ vessel.usageType }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>
              ใบอนุญาตใช้เรือจดทะเบียนล่าสุดวันที่ :
              {{ formateDate(vessel.licenseExpireDate) }}
            </p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>ประเภทเรือ : {{ vessel.vesselType }}</p>
          </vs-col>
          <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
            <p>หมดอายุวันที่ : {{ formateDate(vessel.expireDate) }}</p>
          </vs-col>
        </vs-row>

        <!-- <vs-row class="mt-5 w-full">
          <vs-divider />
        </vs-row> -->
      </div>

      <div class="content-block">
        <p class="mt-10">
          ส่วนที่ 2 ภาพรายละเอียดอุปกรณ์ที่ติดตั้ง หรือแนบรูปเพิ่มเติม
        </p>
        <div class="vx-row mt-10 mx-auto">
          <div class="vx-col w-1/2 mb-10" align="center">
            <img :src="this.imageNameUrl" max-width="350" height="220" />
            <h6 class="mt-5">รูปที่ 1 ชื่อเรือ / เลขทะเบียนเรือ</h6>
          </div>
          <div class="vx-col w-1/2 mb-10" align="center">
            <img :src="this.imageAISDevice" max-width="350" height="220" />
            <h6 class="mt-5">รูปที่ 2 อุปกรณ์ AIS Device</h6>
          </div>
          <div class="vx-col w-1/2 mb-5" align="center">
            <img :src="this.imageVHFAntenna" max-width="350" height="220" />
            <h6 class="mt-5">รูปที่ 3 อุปกรณ์ VHF Antenna</h6>
          </div>
          <div class="vx-col w-1/2 mb-5" align="center">
            <img :src="this.imageGPSAntena" max-width="350" height="220" />
            <h6 class="mt-5">รูปที่ 4 อุปกรณ์ GPS Antenna</h6>
          </div>
        </div>

        <!-- <vs-row class="w-full mb-20">
          <vs-divider />
        </vs-row> -->
      </div>

      <div class="content-block">
        <div class="mx-20 mt-20 mb-20">
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ข้าพเจ้าขอรับรองว่าข้อความในแบบคำขอที่ยื่นมานี้มีความถูกต้องและเป็นจริงทุกประการ
            ตลอดจนจะปฏิบัติตามกฎหมายและระเบียบของทางราชการทุกประการ
            และเมื่อได้รับการติดตั้งอุปกรณ์ระบบสำแดงข้อมูลตัวตนอัตโนมัติ
            (Automatic Identification System : AIS) จากกรมสรรพสามิตแล้ว
            ข้าพเจ้าจะดูแลรักษาอุปกรณ์ระบบฯ ดังกล่าวเป็นอย่างดี
            และหากเกิดการชำรุดเสียหายอันเกิดจากความประมาทเลินเล่อในการปฏิบัติงาน
            ข้าพเจ้ายินยอมชดใช้ค่าเสียหายและค่าซ่อมแซมอุปกรณ์ระบบฯ
            ให้แก่กรมสรรพสามิต
          </p>
        </div>

        <vs-row class="mb-10">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-10"
            v-if="companySealImage"
          >
            <img :src="companySealImage" height="100" />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-5"
          >
            <img
              :src="this.imageSignatureAdminUrl"
              width="25%"
              v-if="imageSignatureAdminUrl"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <span class="flex">
              <p>ลงชื่อ</p>
              <p>
                ........................................................................
              </p>
              <p>(ผู้ติดตั้งอุปกรณ์)</p>
            </span>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-5"
          >
            <p>(บริษัท เปรม กรุ๊ป เอ็นจิเนียริ่ง จำกัด)</p>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-5"
          >
            <p>วันที่ {{ formateDate(new Date()) }}</p>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <p class="mt-20">
              <b>หมายเหตุ : </b>
            </p>
            <p class="mt-20">พร้อมคู่มือการใช้งาน และคู่มือการติดตั้ง</p>
            <br />
          </vs-col>
        </vs-row>
      </div>

      <div align="center" class="my-5">
        <vs-button type="filled" @click.prevent="submitForm" class="mt-5 mr-5"
          >ยืนยันการติดตั้งอุปกรณ์</vs-button
        >
        <vs-button color="danger" type="border" @click="()=> this.$emit('onClosedConfirmInstall', false)">ย้อนกลับ</vs-button>
      </div>
    </div>

    <!-- <div class="demo-alignment">
      <vs-popup
        id="popup-signature"
        class="popup"
        title="ลายเซนต์"
        :active.sync="signaturePopup"
      >
        <popup-signature :passValue="passId"></popup-signature>
      </vs-popup>
    </div> -->
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { Validator } from "vee-validate";
import { INSTALL_ACCESSOIRES } from "../../../mock-data/form-validate.js";
import moment from "moment";
// register custom messages
Validator.localize("en", INSTALL_ACCESSOIRES);
import { ENDPOINT } from "../../../constants/endpoint";
import VueSignaturePad from "vue-signature-pad";
import RegistrationPopup from "../registration-popup/RegistrationPopup.vue"

export default {
  props: {
    dataVessel: Object,
  },
  components: {
    VueSignaturePad,
    RegistrationPopup,
  },
  data() {
    return {
      isComfirm: false,
      url: null,
      info: {},
      vessel: {},
      passId: null,
      vesselSignature: null,
      checkbox: null,
      vesselImage: null,
      rightVesselImage: null,
      leftVesselImage: null,
      AISImage: null,
      vesselImageFile: null,
      rightVesselImageFile: null,
      leftVesselImageFile: null,
      AISImageFile: null,
      documentFiles: [],
      documentFilesURL: [],
      registrationAt: null,
      imageSignatureUserUrl: null,
      imageSignatureSupervisorUrl: null,
      imageSignatureObserverUrl: null,
      imageSignatureAdminUrl: null,
      companySealImage: null,
      signaturePopup: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      console.log("this.dataVessel ", this.dataVessel);
      await this.$store.dispatch(
        `vessels/setVesselById`,
        this.dataVessel.registrationId
      );
      this.info = this.$store.state.vessels.vessel.registration.createdBy;
      console.log("this is infomation :", this.info);
      this.vessel = this.$store.state.vessels.vessel.vessel;
      console.log("this is vessel :", this.$store.state.vessels.vessel);
      this.vesselSignature = this.$store.state.vessels.vessel;

      await this.$store.dispatch("users/setUserById", {
        id: localStorage.getItem("accessUserId"),
      });

      const user = await this.$store.state.users.user;

      console.log("this is user ===> ", user.signatureName);

      this.imageSignatureAdminUrl = user.signatureName
        ? ENDPOINT.GET_IMAGE_SIGNATURE + user.signatureName
        : "";

      const install = this.$store.state.vessels.vessel.installations[0];

      this.info.personType == "บุคคลทั่วไป"
        ? (this.checkbox = "chkPerson")
        : this.info.personType == "นิติบุคคล"
        ? (this.checkbox = "chkLegal")
        : (this.checkbox = "chkOther");

      this.registrationAt = this.vesselSignature.registration.createdAt;

      this.imageNameUrl = ENDPOINT.GET_IMAGE_INSTALL + install.imageNameUrl;
      for (const accessory of install.accessories) {
        if (accessory.type == 1) {
          this.imageAISDevice = ENDPOINT.GET_IMAGE_INSTALL + accessory.imageUrl;
        } else if (accessory.type == 2) {
          this.imageVHFAntenna = ENDPOINT.GET_IMAGE_INSTALL + accessory.imageUrl;
        } else if(accessory.type == 3){
          this.imageGPSAntena = ENDPOINT.GET_IMAGE_INSTALL + accessory.imageUrl;
        }
      }

      if (this.vesselSignature.installations[0].signatures.lenght != 0) {
        for (const signature of this.vesselSignature.installations[0]
          .signatures) {
          if (signature.type == "ผู้ยื่นคำขอ") {
            this.imageSignatureUserUrl =
              ENDPOINT.GET_IMAGE_SIGNATURE + signature.fileName;
          }
          // if(signature.type == "ผู้ดูแลระบบ"){
          //   this.imageSignatureAdminUrl =
          //     ENDPOINT.GET_IMAGE_SIGNATURE + signature.fileName;
          // }
          if (signature.type == "เจ้าพนักงานสรรพสามิต") {
            this.imageSignatureSupervisorUrl =
              ENDPOINT.GET_IMAGE_SIGNATURE + signature.fileName;
          }
          if (signature.type == "ผู้บริหาร") {
            this.imageSignatureObserverUrl =
              ENDPOINT.GET_IMAGE_SIGNATURE + signature.fileName;
          }
        }
      }
    },

    async submitForm() {
      await this.$store.dispatch("users/setUserById", {
        id: localStorage.getItem("accessUserId"),
      });

      const user = await this.$store.state.users.user;

      console.log("this is user ===> ", user.signatureName);

        var payload = {
          registrationId: this.dataVessel.registrationId,
          status: this.dataVessel.value,
          fileName: user.signatureName,
        };

      if (user.signatureName != "" && user.signatureName != null) {
        this.$store.dispatch("vessels/setChangeStatus", payload).then(() => {
          Swal.fire({
            target: document.getElementById("popup-install"),
            icon: "success",
            title: "สำเร็จ",
            text: "ติดตั้งอุปกรณ์เรียบร้อยแล้ว",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            location.reload();
          });
        });
      } else {
        await this.$store
          .dispatch(`vessels/setVesselById`, this.dataVessel.registrationId)
          .then(() => {
            this.signaturePopup = !this.signaturePopup;
            const id = this.$store.state.vessels.vessel.installations[0].id;
            this.passId = {
              id,
              name: "ยืนยันการติดตั้งอุปกรณ์",
              type: "install_user",
              data: payload,
            };
          });
      }
    },
    onVesselImageChange(e) {
      const file = e.target.files[0];
      this.vesselImage = URL.createObjectURL(file);
      this.vesselImageFile = file;
    },
    onRightVesselImageChange(e) {
      const file = e.target.files[0];
      this.rightVesselImage = URL.createObjectURL(file);
      this.rightVesselImageFile = file;
    },
    onLeftVesselImageChange(e) {
      const file = e.target.files[0];
      this.leftVesselImage = URL.createObjectURL(file);
      this.leftVesselImageFile = file;
    },
    onAISImageChange(e) {
      const file = e.target.files[0];
      this.AISImage = URL.createObjectURL(file);
      this.AISImageFile = file;
    },
    formateDate(date) {
      return date && moment(date).add(543, "year").format("DD/MM/YYYY");
    },
    onChangeFiles(e) {
      this.documentFiles = [];
      this.documentFilesURL = [];
      for (const item of e.target.files) {
        this.documentFiles.push(item);
        const url = URL.createObjectURL(item);
        this.documentFilesURL.push(url);
      }
    },
    onClosedSignature(val) {
      this.signaturePopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  padding: 10px 10px 10px 10px;
  width: 400px;
  height: 250px;
  border-style: dotted;
  border-color: #0984e3;
}
.img-show {
  max-width: 370px;
  height: 225px;
}
</style>
